import Hero from "../Hero/Hero";
import TechStack from "../TechStack/TechStack";
import Expertise from "../Expertise/Expertise";
import WhyUs   from "../WhyUs/WhyUs"
import Services from "../Services/Services"
import FAQ from "../FAQ/FAQ";
import Testimonials from "../Testimonials/Testimonials"
import Clients from "../Portfolio/Clients"
import  Whatsapp from "../Whatsapp/Whatsapp"
import Chatbot from "../Chatbot/Chatbot";
function Home() {
  return (
    <>
      <Hero />
      <Expertise />
      <TechStack />
      <Services/>
      <Clients/>
      <WhyUs/>
      <Testimonials/>
      <FAQ/>
      <Whatsapp/>
      <Chatbot/>
      
    </>
  );
}

export default Home;